import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { BookingService } from 'src/modules/services/booking.service';
import { Notes } from 'src/modules/models/booking/booking-notes';
import { Booking } from 'src/modules/models/booking/booking';

import { AlertMessageComponent } from 'src/modules/shared/alert-message/alert-message.component';
import { SuccessMessageComponent } from 'src/modules/shared/success-message/success-message.component'

import { EntityType, NoteType } from 'src/modules/models/bookingNotes-enum';
import {environment} from '../../../../environments/environment';
import {RegularBookingSettings} from '../../../models/settings/regular-portal/regular-booking-setting';
import {SafeHtml} from '@angular/platform-browser';
import {AppSetting} from '../../../models/settings/casual-portal/app-setting';

@Component({
    selector: 'opt-cancel-booking',
    templateUrl: './cancel-booking.component.html',
    styleUrls: ['./cancel-booking.component.scss']
})

export class CancelBookingComponent {

    showLoader: boolean = false;
    requestString: string;
    bookingTypeId: number;
    cancellationPopupMessageHTML: SafeHtml;

    constructor(public dialogRef: MatDialogRef<CancelBookingComponent>, public snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any, private _bookingService: BookingService) {

        this.bookingTypeId = this.data.booking.bookingTypeId;
        var appSetting = environment.AppSetting as AppSetting;
        this.cancellationPopupMessageHTML = appSetting?.BookingConfig?.Messages?.CancellationPopupMessageHTML ?? "";
    }


    confirm() {
        this.showLoader = true;

        var booking = new Booking();
        if( this?.data?.booking?.bookingQuestionnaires != null){
          this.data.booking.bookingQuestionnaires = undefined;
        }
        booking = this.data.booking;
        booking.id = this.data.booking.bookingId;
        booking.bookingTypeId = this.bookingTypeId;
        booking.bookingReference = this.data.booking.bookingRef;
        booking.notes = [];


        if (this.requestString && this.requestString.length) {
            var bookingNotes = new Notes();
            bookingNotes.plainText = this.requestString;
            bookingNotes.entityTypeID = EntityType.Booking;
            bookingNotes.entityType = 'Booking';
            bookingNotes.noteTypeId = NoteType.CancelRequest;
            bookingNotes.noteType = 'Booking Cancel Request';
            const excludedBookingTypes = [0, 1, 6, 7, 8];
            if (!excludedBookingTypes.includes(this.bookingTypeId)) {
              var _regularXmlData = (environment.RegularBookingSetting as RegularBookingSettings);
              var _filteredBookingType = _regularXmlData.booking.bookingTypes.find(x => x.id == this.bookingTypeId.toString());
            if(_filteredBookingType.name != null){
              bookingNotes.bookingType= _filteredBookingType.name;
            }

            }else{
              bookingNotes.facilityName = this.data.facilityName;
            }
            booking.notes.push(bookingNotes);

        }
        this._bookingService.BookingCancelPatch(this.data.booking.bookingId, booking).subscribe(result => {
            if (result) {
                if (result.body.data != null && result?.body?.data?.cancelled) {
                    this.openSnackBarSuccess(["Your request has been forwarded and we will respond shortly."]);
                }
                else if (result.body.isError) {
                    this.openSnackBarError(['Booking cancel request has been failed, ' + result.body.errors[0].detail]);
                }

                setTimeout(() => {
                    this.showLoader = false;
                    this.dialogRef.close(true);
                }, 2000);

            } else {
                this.showLoader = false;
                this.openSnackBarError(['Booking cancel request has been failed. Please try again.']);
                this.dialogRef.close(false);
            }
        });
        // commented to fix Bug 24529: IWC-Azure Test - Request cancellation Processing banner UI issue (processing banner should be in the front )
                this.dialogRef.close(true);
    }

    openSnackBarSuccess(message) {
        this.snackBar.openFromComponent(SuccessMessageComponent, {
            data: message,
            duration: 4000,
            verticalPosition: 'top'
        });
    }

    openSnackBarError(message) {
        this.snackBar.openFromComponent(AlertMessageComponent, {
            data: message,
            duration: 4000,
            verticalPosition: 'top'
        });
    }
}
